import BaseConfig from '@/config/config';
import type { Config } from '@/config/types.config';

import { createApiConfig } from '@/api/helpers.api';

const API_V1_BASE_PATH = 'https://stage.classic.saljaot.selling.ingka.com';
const API_V2_BASE_PATH = 'https://stage.saljaot.selling.ingka.com';
const FUNCTION_ENDPOINT_BASE_PATH = 'https://stage-bff.saljaot.selling.ingka.com';

const messagesFeatureConfig = {
    add: {
        enable: true,
    },
    edit: {
        enable: true,
    },
    read: {
        enable: true,
    },
};

const config: Config = {
    ...BaseConfig,
    api: {
        ...createApiConfig({
            classicSaljaBaseUrl: API_V1_BASE_PATH,
            orderTakingBaseUrl: API_V2_BASE_PATH,
            orderTakingBffBaseUrl: FUNCTION_ENDPOINT_BASE_PATH,
        }),
    },
    cartDomain: 'https://stage.coworker.ingka.com',
    cartPath: 'v1/cart',
    cartHomePath: 'v1',
    feature: {
        ...BaseConfig.feature,
        fragments: {
            orderHistory: true,
            manualPayments: true,
        },
        messages: {
            ...BaseConfig.feature.messages,
            TSP_CUST: messagesFeatureConfig,
            INTERNAL: messagesFeatureConfig,
            EXTERNAL: {
                ...BaseConfig.feature.messages?.EXTERNAL,
                read: {
                    enable: true,
                },
            },
        },
        docusign: {
            enable: false,
            acceptedFileTypes: ['.pdf'],
        },
        draftV2Service: {
            enable: true,
        },
        showPriceSummary: {
            enable: true,
        },
        commandMenu: {
            enable: true,
        },
        questionnaire: {
            ...BaseConfig.feature.questionnaire,
            read: {
                ...BaseConfig.feature.questionnaire?.read,
                enable: true,
            },
        },
        paymentDateModification: {
            ...BaseConfig.feature.paymentDateModification,
            read: {
                ...BaseConfig.feature.paymentDateModification?.read,
                enable: true,
            },
            edit: {
                ...BaseConfig.feature.paymentDateModification?.edit,
                enable: true,
            },
        },
        pickingListPdf: {
            ...BaseConfig.feature.pickingListPdf,
            enable: true,
        },
    },
    shareOptions: {
        ...BaseConfig.shareOptions,
    },
} as const;

export default config;
